<template>
  <div
    v-if="value && value.length >= 0"
    v-loading="uploading"
    class="tournament-light-grey rounded pa-4 column"
    element-loading-text="Carregando..."
  >
    <div
      class="column"
      :class="documentsValue && documentsValue.length ? 'mb-3' : ''"
    >
      <QueuedUploadList
        ref="uploader"
        :key="value._id"
        v-model="documentsValue"
        class="row wrap"
        style="flex-wrap: wrap; justify-content: space-between"
        upload-class="py-2 pl-3 pr-2 my-2 white elevate-2 ra-1"
        upload-style="width: calc(50% - 8px);"
        :limit="0"
        :disabled="!isEditable"
        @selected="changeFileName($event)"
      />
    </div>

    <div>
      <el-button
        v-if="isEditable"
        style="height: 36px"
        icon="el-icon-upload2"
        class="tournament-light-blue tournament-white--text rounded no-border no-selection"
        @click="openUploadDialog()"
      >
        SELECIONAR ARQUIVOS
      </el-button>
    </div>

    <v-snackbar :value="isUploading" color="info" :timeout="0">
      Enviando arquivos
      <v-progress-circular indeterminate color="white" :size="24" :width="2" />
    </v-snackbar>
  </div>
</template>

<script>
import _ from "lodash";

import QueuedUploadList from "@/components/QueuedUploadList";
export default {
  name: "EnrollmentSubmitDocuments",

  components: {
    QueuedUploadList,
  },

  props: {
    value: {
      type: Array,
      default: () => [],
    },
    enrollmentStatus: {
      type: String,
      required: true,
    },
    teamId: {
      type: String,
      default: "",
    },
    members: {
      type: Array,
      required: true,
    },
    coach: {
      type: Array,
      required: true,
    },
    mainCoach: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      // is is uploading or not
      uploading: false,
      filePrefix: "",
    };
  },

  computed: {
    isEditable() {
      return this.enrollmentStatus == "waiting";
    },

    documentsValue: {
      get() {
        return this.value;
      },
      set(v) {
        this.$emit("input", v);
      },
    },

    users() {
      return _(this.members)
        .castArray()
        .concat(_.castArray(this.coach))
        .concat(_.castArray(this.mainCoach))
        .compact()
        .value();
    },

    isUploading() {
      return this.value.some((up) => up.$upload && up.$upload.running);
    },
  },

  created() {
    // Keep safe when parent pass a undefined as prop
    if (!this.value) {
      return this.$emit("input", []);
    }
  },

  methods: {
    async openUploadDialog() {
      const answer = await this.$confirmDialog({
        width: this.$vuetify.breakpoint.xsOnly ? "95%" : "330px",
        default: false,
        inputType: "select",
        title: "Enviar anexo para:",
        items: this.users.map((user) => ({ value: user, text: user.name })),
      });

      if (!answer) return;

      // Prepare prefix
      this.filePrefix = `${answer.alias} - ${answer.name} - `;

      // Wait window close and open upload
      setTimeout(() => this.$refs.uploader.openUpload(), 400);
    },

    changeFileName(upload) {
      upload.customName = this.filePrefix + upload.name;
      this.filePrefix = "";
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/Enrollments/Submit/Documents.vue